import { CertificatesSidebar } from './CertificatesSidebar';
import { LoaderFunction, Outlet, useSearchParams } from 'react-router-dom';
import { PageHeader } from '@mosey/components/page-header/PageHeader';
import { PageTitle } from '@mosey/components/page-header/PageTitle';
import { IFetchApi } from '../../utils/types';
import { apiBatch } from '../../utils/fetchApi';
import { CategoryFilter } from './components/CategoryFilter';
import { DocumentRegionFilter } from './components/DocumentRegionFilter';
import {
  useDocumentCenterData,
  useDocumentsByCategory,
  useFilteredDocuments,
} from './utils/hooks';
import { NoDocumentsFoundPanel } from './components/NoDocumentsFoundPanel';

export const loader: LoaderFunction = async () => {
  const calls: Record<string, IFetchApi> = {
    categories: {
      url: '/api/documents/categories',
      method: 'GET',
    },
    types: {
      url: '/api/documents/types',
      method: 'GET',
    },
    documents: {
      url: '/api/documents',
      method: 'GET',
    },
  };

  return apiBatch(calls);
};

export const CertificatesLayout = () => {
  const { documentsByCategory } = useDocumentsByCategory();
  const { documents } = useDocumentCenterData();
  const { categories, selectedRegion } = useFilteredDocuments();
  const [searchParams] = useSearchParams();

  const categoryIdParam = searchParams.get('category');
  const categoryId = categoryIdParam ? Number(categoryIdParam) : null;

  const showMain =
    (categoryId === null ||
      (documentsByCategory[categoryId]?.length ?? 0) > 0) &&
    documents.length > 0;

  const selectedCategory = categories.find((cat) => cat.id === categoryId);

  const hasDocs = documents.length > 0;

  let description: string;
  if (selectedCategory && selectedRegion) {
    description = `No documents found for ${selectedCategory.name.toLowerCase()} in ${selectedRegion.name}`;
  } else if (hasDocs) {
    description = 'We could not find any documents matching your filters.';
  } else {
    description = 'We could not find any documents.';
  }

  return (
    <div className="flex h-full flex-col bg-white">
      <PageHeader>
        <PageTitle>Documents</PageTitle>
        <CategoryFilter />
        <DocumentRegionFilter />
      </PageHeader>

      {showMain ? (
        <div className="flex grow overflow-hidden">
          <CertificatesSidebar />
          <main className="flex-1 overflow-y-auto p-6">
            <Outlet />
          </main>
        </div>
      ) : (
        <NoDocumentsFoundPanel
          showBackButton={documents.length > 0}
          description={description}
        />
      )}
    </div>
  );
};
